import React from "react";
import { Box } from "@mui/material";
import Tool from "./Tool";

const Home = () => {
  return (
    <Box>
        <Tool />
    </Box>
  );
};

export default Home;
